/** Extrai a mensagem pública dos erros gerados por apiRequest ("STATUS: corpo"). */
export function apiErrorMessage(error: unknown, fallback = "Tente novamente ou contate o suporte"): string {
  const raw = error instanceof Error ? error.message : typeof error === "string" ? error : "";
  const body = raw.match(/^\d{3}: ([\s\S]*)$/)?.[1];
  if (!body) return raw || fallback;

  try {
    const parsed = JSON.parse(body);
    if (parsed && typeof parsed.message === "string" && parsed.message.trim()) return parsed.message;
  } catch {
    // Respostas não JSON (proxy/rede) continuam legíveis, sem esconder o texto original.
  }
  return body || fallback;
}
